(() => {
  const container = document.querySelector('.scroll-container');

  let isDown = false;
  let startX;
  let startY;
  let scrollLeft;
  let scrollTop;

  container.addEventListener('mousedown', (e) => {
    isDown = true;
    container.classList.add('active');
    startX = e.pageX - container.offsetLeft;
    startY = e.pageY - container.offsetTop;
    scrollLeft = container.scrollLeft;
    scrollTop = container.scrollTop;
  });

  container.addEventListener('mouseleave', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mouseup', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const y = e.pageY - container.offsetTop;
    const walkX = x - startX;
    const walkY = y - startY;
    container.scrollLeft = scrollLeft - walkX;
    container.scrollTop = scrollTop - walkY;
  });

  container.querySelectorAll('img').forEach(img => {
    img.addEventListener('dragstart', e => e.preventDefault());
  });

  const scrollContainer = container;
  const nextBtn = document.querySelector('.upsell-gallery-next-btn');
  const prevBtn = document.querySelector('.upsell-gallery-prev-btn');

  function getScrollStep() {
    const firstImage = scrollContainer.querySelector('img');
    if (!firstImage) return 0;
    const styles = getComputedStyle(scrollContainer);
    const gap = parseInt(styles.gap || styles.columnGap || 0);
    const imgWidth = firstImage.offsetWidth;
    return imgWidth + gap;
  }

  nextBtn?.addEventListener('click', () => {
    const step = getScrollStep();
    const remaining = scrollContainer.scrollWidth - scrollContainer.clientWidth - scrollContainer.scrollLeft;
    const scrollBy = remaining < step ? remaining : step;
    scrollContainer.scrollBy({ left: scrollBy, behavior: 'smooth' });
  });

  prevBtn?.addEventListener('click', () => {
    const step = getScrollStep();
    const scrollBy = scrollContainer.scrollLeft < step ? scrollContainer.scrollLeft : step;
    scrollContainer.scrollBy({ left: -scrollBy, behavior: 'smooth' });
  });


  function openUpsellDrawer() {
    document.querySelector('.drawer-upsell')?.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeUpsellDrawer() {
    document.querySelector('.drawer-upsell')?.classList.remove('active');
    document.documentElement.style.overflow = '';
  }

  ['#add-to-cart-btn', '#upsell-container'].forEach(selector => {
    document.querySelector(selector)?.addEventListener('click', (e) => {
      e.preventDefault();
      openUpsellDrawer();
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const drawerWrapper = document.querySelector('.drawer-upsell');
    const drawerContent = document.querySelector('#UpsellDrawer');
    const closeButton = document.querySelector('.upsell-drawer .icon-close');

    function closeUpsellDrawer() {
      drawerWrapper?.classList.remove('active');
      document.documentElement.style.overflow = '';
    }

    closeButton?.addEventListener('click', () => {
      closeUpsellDrawer();
    });

    document.addEventListener('click', function(event) {
      if (!drawerWrapper || !drawerContent) return;

      const clickInsideWrapper = drawerWrapper.contains(event.target);
      const clickInsideContent = drawerContent.contains(event.target);

      if (clickInsideWrapper && !clickInsideContent) {
        closeUpsellDrawer();
      }
    });
  });

  document.querySelector('#upsell-drawer-add-to-cart')?.addEventListener('click', () => {
    closeUpsellDrawer();
  });
})();
